import React from 'react'
import styled from '@emotion/styled'
import Box from './Box'
import { SIXTEEN_PX, TWELVE_PX } from '../enums/Spacings'
import appleWalletImage from '/apple-wallet-image.svg'
import googleWalletImage from '/google-wallet-badge.svg'

const WalletButtonsContainer = styled(Box)`
  margin-bottom: ${SIXTEEN_PX};
  width: 100%;
  flex-wrap: wrap;
`

const WalletLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  text-decoration: none;
  transition: opacity 0.2s ease;
  border: none;
  background: none;

  &:hover {
    opacity: 0.85;
  }
`

const WalletIcon = styled.img`
  width: 160px;
  height: auto;

  @media (min-width: 1024px) {
    width: 200px;
  }

  @media (max-width: 768px) {
    width: 140px;
  }
`

interface AddToWalletButtonsProps {
  appleWalletUrl: string | null
  googleWalletUrl: string | null
}

export const AddToWalletButtons: React.FC<AddToWalletButtonsProps> = ({ appleWalletUrl, googleWalletUrl }) => {
  if (!appleWalletUrl && !googleWalletUrl) return null

  return (
    <WalletButtonsContainer direction="row" align="center" justify="center" gap={TWELVE_PX} fullWidth>
      {appleWalletUrl && (
        <WalletLink href={appleWalletUrl} target="_blank" rel="noopener noreferrer" aria-label="Add to Apple Wallet">
          <WalletIcon src={appleWalletImage} alt="Add to Apple Wallet" />
        </WalletLink>
      )}
      {googleWalletUrl && (
        <WalletLink href={googleWalletUrl} target="_blank" rel="noopener noreferrer" aria-label="Add to Google Wallet">
          <WalletIcon src={googleWalletImage} alt="Add to Google Wallet" />
        </WalletLink>
      )}
    </WalletButtonsContainer>
  )
}
